import React, { useState } from 'react';

const usd = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const short = (a) => (a ? `${a.slice(0, 8)}…${a.slice(-4)}` : '');
const small = 'px-2 py-1 rounded text-xs disabled:opacity-40';
const inp = 'w-28 px-2 py-1 bg-slate-700 border border-slate-600 rounded text-white text-xs';

const AssetRow = ({ a, busy, post }) => {
  const [val, setVal] = useState('');
  const [ref, setRef] = useState('');
  return (
    <tr className="border-t border-slate-700" data-testid={`stablecoin-asset-${a.id}`}>
      <td className="py-2">#{a.id}</td>
      <td className="font-mono text-xs">{short(a.custodian)}</td>
      <td>{usd(a.face_usd)}</td>
      <td>{usd(a.market_usd)}</td>
      <td>{a.maturity || '-'}</td>
      <td className="capitalize">{a.status}</td>
      <td className="space-x-1 whitespace-nowrap">
        {a.status === 'held' && (<>
          <input className={inp} placeholder="USD value" value={val} onChange={(e) => setVal(e.target.value)} data-testid={`stablecoin-asset-${a.id}-value`} />
          <button disabled={busy || !val} className={`${small} bg-slate-600 text-white`} data-testid={`stablecoin-asset-${a.id}-revalue`}
            onClick={() => post(`assets/${a.id}/value`, { market_usd: parseFloat(val) }, () => setVal(''))}>Revalue</button>
          <input className={inp} placeholder="Sale reference" value={ref} onChange={(e) => setRef(e.target.value)} data-testid={`stablecoin-asset-${a.id}-ref`} />
          <button disabled={busy || !val || !ref} className={`${small} bg-amber-500 text-slate-900`} data-testid={`stablecoin-asset-${a.id}-liquidate`}
            onClick={() => post(`assets/${a.id}/liquidate`, { proceeds_usd: parseFloat(val), reference: ref })}>Sold for value</button>
        </>)}
      </td>
    </tr>
  );
};

export const StablecoinAssets = ({ assets, busy, post }) => (
  <div data-testid="stablecoin-assets">
    <p className="text-sm text-slate-300 font-medium mb-2">Treasury assets</p>
    {!assets?.length ? <p className="text-xs text-slate-500">No Treasury assets recorded yet.</p> : (
      <div className="overflow-x-auto"><table className="w-full text-sm text-slate-300">
        <thead><tr className="text-xs text-slate-500 text-left"><th>ID</th><th>Custodian</th><th>Face</th><th>Market</th><th>Matures</th><th>Status</th><th /></tr></thead>
        <tbody>{assets.map(a => <AssetRow key={a.id} a={a} busy={busy} post={post} />)}</tbody>
      </table></div>
    )}
  </div>
);

const RedemptionRow = ({ r, busy, post }) => {
  const [ref, setRef] = useState('');
  return (
    <tr className="border-t border-slate-700" data-testid={`stablecoin-redemption-${r.id}`}>
      <td className="py-2">#{r.id}</td>
      <td className="font-mono text-xs">{short(r.holder)}</td>
      <td>{usd(r.amount)}</td>
      <td className="capitalize" data-testid={`stablecoin-redemption-${r.id}-status`}>{r.status}</td>
      <td className="space-x-1 whitespace-nowrap">
        {r.status === 'pending' && (<>
          <input className={inp} placeholder="Payment reference" value={ref} onChange={(e) => setRef(e.target.value)} data-testid={`stablecoin-redemption-${r.id}-ref`} />
          <button disabled={busy || !ref} className={`${small} bg-emerald-600 text-white`} data-testid={`stablecoin-redemption-${r.id}-paid`}
            onClick={() => post(`redemptions/${r.id}/paid`, { reference: ref })}>USD paid</button>
          <button disabled={busy} className={`${small} bg-slate-600 text-white`} data-testid={`stablecoin-redemption-${r.id}-cancel`}
            onClick={() => post(`redemptions/${r.id}/cancel`)}>Cancel</button>
        </>)}
      </td>
    </tr>
  );
};

export const StablecoinRedemptions = ({ redemptions, busy, post }) => (
  <div data-testid="stablecoin-redemptions">
    <p className="text-sm text-slate-300 font-medium mb-2">USD redemptions</p>
    {!redemptions?.length ? <p className="text-xs text-slate-500">No redemptions yet.</p> : (
      <div className="overflow-x-auto"><table className="w-full text-sm text-slate-300">
        <thead><tr className="text-xs text-slate-500 text-left"><th>ID</th><th>Holder</th><th>Amount</th><th>Status</th><th /></tr></thead>
        <tbody>{redemptions.map(r => <RedemptionRow key={r.id} r={r} busy={busy} post={post} />)}</tbody>
      </table></div>
    )}
  </div>
);
